module.exports = __webpack_public_path__ + "static/media/galerija_2019 (4).9aea1831.jpg";